import { inject, Injectable } from '@angular/core';
import { ExportService } from '../../services/export/export.service';
import { LinkRegistryService } from '../../services/link-registry.service';
import { WINDOW_TOKEN } from '../../services/bootstrap.service';

import type { LinkParameters } from '../../services/link-registry.service';
import type { ExportRequest } from '../../services/export/export.domain';
import type { OpenWindowParameters } from './open-window.directive';

@Injectable({
  providedIn: 'root'
})
export class OpenWindowService {

  private readonly DEFAULT_WINDOW_PARAMS: string = 'height=768,width=1024,scrollbars=1';

  private browserWindow: Window = inject(WINDOW_TOKEN);
  private linkRegistryService: LinkRegistryService = inject(LinkRegistryService);
  private exportService: ExportService = inject(ExportService);

  getUrl(linkId: string, parameters: OpenWindowParameters): string {
    let url;
    if (linkId === '$export') {
      url = this.exportService.getUrl(parameters as ExportRequest);
    } else {
      url = this.linkRegistryService.getLink(linkId, parameters as LinkParameters);
    }
    if (url === '#') {
      url = linkId;
    }
    return url;
  }

  open(linkId: string, parameters?: OpenWindowParameters, windowName?: string, windowParams?: string): void {
    if (windowParams === undefined) {
      windowParams = this.DEFAULT_WINDOW_PARAMS;
    }
    this.browserWindow.open(this.getUrl(linkId, parameters), windowName, windowParams);
  }

}
